/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBaby = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4 12a8.003 8.003 0 0 1 6.04-7.758c-.11.294-.174.623-.174.99a3 3 0 0 0 3 3v-2a1 1 0 0 1-1-1c0-.384.242-.739 1.104-1.174A8.001 8.001 0 0 1 12 20a8 8 0 0 1-8-8zm8-10C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 14a3 3 0 0 1-3-3H7a5 5 0 0 0 10 0h-2a3 3 0 0 1-3 3zm-4-6v2h2v-2zm6 0v2h2v-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBaby as Baby };
